<ng-container [formGroup]="model">
    @if (!isEditable) {
        <div style="pointer-events:none;">
            <p-toggleswitch
                [inputId]="field.name"
                [formControlName]="field.name"
                [attr.aria-describedby]="describedById || null"
                [trueValue]="1"
                [falseValue]="0"
            [attr.aria-invalid]="isInvalid">
            </p-toggleswitch>
        </div>
    } @else {
        <p-toggleswitch
            [inputId]="field.name"
            [formControlName]="field.name"
            [attr.aria-describedby]="describedById || null"
            [trueValue]="1"
            [falseValue]="0"
            [attr.aria-invalid]="isInvalid">
        </p-toggleswitch>
    }
</ng-container>
